import { useState, createContext, useEffect, useCallback } from 'react';
import MyFunctions from '../Functions/MyFunctions';

export const UserContext = createContext();

export const UserContextProvider = props => {
    const [user, setUser] = useState();
    const [refreshTrigger, setRefreshTrigger] = useState(false);

    const userChecking = useCallback(async () => {
        let bk = await MyFunctions.connCheck();
        if (bk !== null) {
            setUser(bk.user);
        } else {
            let emptyUser = {
                firstName: "",
                lastName: "",
                phone: "",
                email: "",
                rest: "",
            }
            setUser(emptyUser);
        }
    }, []);

    useEffect(() => {
        userChecking();
    }, [userChecking, refreshTrigger]);

    useEffect(() => {
        if (user?.token) {
            localStorage.setItem("napoUsrToken", user.token);
        }
    }, [user]);

    const UserEffectFunction = useCallback(() => {
        setRefreshTrigger(prev => !prev);
    }, []);

    const logout = useCallback(() => {

        localStorage.removeItem("napoUsrToken");
        let emptyUser = {
            firstName: "",
            lastName: "",
            phone: "",
            email: "",
            rest: "",
        }
        setUser(emptyUser);
    }, []);

    return (
        <UserContext.Provider value={[user, setUser, UserEffectFunction, logout]}>
            {props.children}
        </UserContext.Provider>
    );
};